<template>
  <el-container>
    <el-aside class="main-aside">
      <el-container>
        <el-header class="left-houselist">
          <el-input placeholder="请输入小区名称" v-model="likeData"></el-input>
          <el-button type="primary" @click="getHousingList()">查询</el-button>
        </el-header>
        <el-main>
          <el-table
            :data="tableData"
            :show-header="false"
            ref="tablesure"
            highlight-current-row
            default-expand-all
            @row-click="houseClick"
            row-key="userId"
            :tree-props="{ children: 'users' }"
          >
            <el-table-column prop="userName" label="名字"> </el-table-column>
          </el-table>
        </el-main>
      </el-container>
    </el-aside>
    <el-main class="main-main">
      <el-container>
        <el-header>
          <el-input
            class="h-i-q h-m-r"
            placeholder="请输入姓名搜索"
            v-model="otherData.userName"
          ></el-input>
          <el-select
            class="h-m-r"
            placeholder="请选择状态"
            v-model="otherData.status"
          >
            <el-option value="0" label="待入场"></el-option>
            <el-option value="1" label="在场"></el-option>
            <el-option value="2" label="待出场"></el-option>
            <el-option value="3" label="已离场"></el-option>
          </el-select>
          <el-select
            class="h-m-r"
            placeholder="请选择类型"
            v-model="otherData.types"
          >
            <el-option value="1" label="普通住户"></el-option>
            <el-option value="2" label="户主"></el-option>
            <el-option value="3" label="外来访客"></el-option>
            <el-option value="4" label="物业人员"></el-option>
          </el-select>
          <el-date-picker
            class="h-m-r"
            v-model="timeall"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            :clearable="false"
            value-format="yyyy-MM-dd"
            @change="gettimeall"
          >
          </el-date-picker>
          <el-button type="primary" @click="clearotherData()"
            >清空条件</el-button
          >
          <el-button type="primary" @click="queryPassList(true)">查询</el-button>
          <el-button type="primary" @click="downPassList()">导出表格</el-button>
          <el-link
            :href="Excel"
            download="导出表格.xls"
            style="disply:none"
            id="link"
          ></el-link>
        </el-header>
        <el-main>
          <el-table
            :data="passList"
            border
            :header-cell-style="{ background: '#409EFF', color: '#fff' }"
          >
            <el-table-column
              prop="userName"
              label="姓名"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="types"
              label="人员类型"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="status"
              label="在场状态"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="entranceTime"
              label="进场时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="exitTime"
              label="出场时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="stayTime"
              label="停留时间"
              align="center"
            ></el-table-column>
            <el-table-column label="入场通道" align="center">
              <template slot-scope="scope">
                <el-link @click="lookentrance(scope.row)" type="primary">{{
                  scope.row.EntranceDrivewayName
                }}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="出场通道" align="center">
              <template slot-scope="scope">
                <el-link @click="lookexit(scope.row)" type="primary">{{
                  scope.row.ExitDrivewayName
                }}</el-link>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog width="400px" title="图片" :visible.sync="photoVisiBle">
            <img :src="photourl" width="320px" alt="" />
          </el-dialog>
        </el-main>
        <el-footer>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </el-footer>
      </el-container>
    </el-main>
    <div v-show="this.loading1" class="big">
      <div
        class="loading"
        v-loading=true
        element-loading-text="加载中，请稍后..."
        element-loading-background="rgba(96, 96, 96, 0.5)"
      ></div>
    </div>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      tableData: [], //小区列表
      likeData: "", //模糊查询
      //分页参数
      pageSize: 20,
      currentPage: 1,
      total: 100,
      unitId: "",
      timeall: "",
      otherData: {
        userName: "",
        status: "",
        types: "",
        startDate: "",
        endDate: ""
      },
      passList: [],
      photoVisiBle: false,
      photourl: "",
      baseURL: this.$axios.defaults.baseURL,
      Excel: "", //下载的href
      loading1: false //控制加载动画
    };
  },
  computed: {
    ...mapGetters(["userinfo"])
  },
  created() {
    this.getHousingList();
  },
  methods: {
    getHousingList() {
      let url = "/dapi/u/likeSelectUserInfo";
      let params = {
        uid: this.userinfo.uid,
        likeData: this.likeData
      };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.tableData = [];
          data.data.map(item => {
            if (item.userRoleCode == 3 || item.userRoleCode == 9) {
              this.tableData.push(item);
            }
            if (item.users && item.users.length > 0) {
              let users = item.users.filter(
                k => k.userRoleCode == 3 || k.userRoleCode == 9
              );
              item.users = users;
              this.tableData.push(item);
            }
          });
          // this.tableData = data.data;
          // this.$refs.tablesure.setCurrentRow(this.tableData[0]);
          this.$nextTick(() => {
            this.$refs.tablesure.setCurrentRow(this.tableData[0]);
          });
          if (this.tableData[0].users != undefined) {
            if (
              this.tableData[0].users != "" &&
              this.tableData[0].users.length > 0
            ) {
              this.houseClick(this.tableData[0].users[0]);
              return;
            }
          }
          this.houseClick(this.tableData[0]);
        }
      });
    },
    houseClick(row) {
      this.unitId = row.userId;
      this.timeall = "";
      this.otherData.userName = "";
      this.otherData.startDate = "";
      this.otherData.endDate = "";
      this.otherData.status = "";
      this.otherData.types = "";
      this.queryPassList();
    },
    /*
     **  @description 清空条件
     **  @param {}
     **  @return
     **  @author shipingan
     */
    clearotherData() {
      this.timeall = "";
      this.otherData.userName = "";
      this.otherData.startDate = "";
      this.otherData.endDate = "";
      this.otherData.status = "";
      this.otherData.types = "";
    },
    /*
     **  @description 查询记录
     **  @param {}
     **  @return
     **  @author shipingan
     */
    queryPassList(val) {
      if (val) {
        this.currentPage = 1
      }
      let url = "/dapi/dri/selectUserRecordByUnitId";
      let params = { ...this.otherData };
      params.currentPage = this.currentPage;
      params.pageSize = this.pageSize;
      params.unitId = this.unitId;
      this.loading1 = true;
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        this.loading1 = false;
        let data = res.data;
        if (data.status == 200) {
          this.passList = [];
          this.total = data.rowCount;
          this.passList = data.data;
        }
      });
    },
    lookentrance(row) {
      this.photourl = row.entrancePhoto;
      this.photoVisiBle = true;
    },
    lookexit(row) {
      this.photourl = row.exitPhoto;
      this.photoVisiBle = true;
    },

    /*
     **  @description 下载数据
     **  @param {}
     **  @return
     **  @author shipingan
     */
    downPassList() {
      let url = "/dapi/dri/selectExportUserRecord";
      let params = { ...this.otherData };
      params.unitId = this.unitId;
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.Excel = `${this.baseURL}/dapi/dri/exportUserRecord`;
          // let link = document.getElementById("link");
          // link.click();
          window.open(this.Excel);
        }
      });
    },
    gettimeall() {
      this.otherData.startDate = this.timeall[0];
      this.otherData.endDate = this.timeall[1];
    },
    /*
     **  @description 分页
     **  @param {}
     **  @return
     **  @author shipingan
     */
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryPassList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryPassList();
    }
  }
};
</script>
<style lang="less" scoped>
@box-shadow: 0px 0px 10px #ccc;
.el-container {
  height: 100%;
  .main-aside {
    box-shadow: @box-shadow;
    .left-houselist {
      display: flex;
      box-sizing: border-box;
      padding: 16px 20px;
      justify-content: space-between;
      box-shadow: @box-shadow;
      .el-input {
        width: 180px;
        margin-right: 10px;
      }
    }
    .el-main {
      padding-top: 10px;
    }
  }
  .main-main {
    padding: 0;
    .el-header {
      text-align: left;
      box-shadow: @box-shadow;
      min-width: 400px;
      line-height: 60px;
      min-width: 1300px;
      .h-i-q {
        width: 200px;
      }
      .h-m-r {
        margin-right: 10px;
      }
    }
    .el-main {
      min-width: 1300px;
    }
    .el-link {
      font-size: 12px;
    }
  }
  .el-foolter {
    text-align: center;
  }
}
.big{
  width: 100%;
  height: 100%;
  //background: rgba(red, green, blue, alpha);
  background: rgba(red, green, blue, alpha);
  position: absolute;
  top: 0;
  left: 0;
}
.loading{
  border: none;
  border-radius: 10px;
  box-shadow: 0px 0px 15px #bbabab;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 30%;
  height: 20%;
  transform: translate(-50%,-50%);
}

</style>
